import { Alert, Center, Loader, Stack, Text } from '@mantine/core';
import { IconAlertTriangle, IconInbox } from '@tabler/icons-react';
import type { ReactNode } from 'react';

import { errorMessage } from '@/api/client';

export function ErrorAlert({
  error,
  title = 'Chargement impossible',
}: {
  error: unknown;
  title?: string;
}) {
  return (
    <Alert color="red" icon={<IconAlertTriangle size={18} />} title={title}>
      {errorMessage(error)}
    </Alert>
  );
}

export function EmptyState({ children, icon }: { children: ReactNode; icon?: ReactNode }) {
  return (
    <Center py="xl">
      <Stack align="center" gap="xs">
        {icon ?? <IconInbox size={32} stroke={1.5} color="var(--mantine-color-dimmed)" />}
        <Text c="dimmed" size="sm" ta="center">
          {children}
        </Text>
      </Stack>
    </Center>
  );
}

/** Rendu standard d'une requête : chargement, erreur, vide, contenu. */
export function QueryState<T>({
  query,
  empty,
  isEmpty,
  children,
}: {
  query: { isPending: boolean; isError: boolean; error: unknown; data: T | undefined };
  empty?: ReactNode;
  isEmpty?: (data: T) => boolean;
  children: (data: T) => ReactNode;
}) {
  if (query.isPending) {
    return (
      <Center py="xl">
        <Loader size="sm" />
      </Center>
    );
  }
  if (query.isError || query.data === undefined) return <ErrorAlert error={query.error} />;
  if (empty && isEmpty?.(query.data)) return <EmptyState>{empty}</EmptyState>;
  return <>{children(query.data)}</>;
}
